module.exports = __webpack_public_path__ + "static/media/check-icon-yellow.74e99424.svg";